module.exports = __webpack_public_path__ + "static/media/check-all.5772fb25.svg";